module.exports = __webpack_public_path__ + "img/empty.9ba3fd54.png";